export default __webpack_public_path__ + "static/media/onboarding-background.ec50d348.png";